import {
  PackagedAirV2,
  PackagedComponentEntryV2,
  PackagedComponentV2,
  PackagedComponentV2Enum,
  PackagedRoomComponentV2,
  PackageDisplayData,
} from "@capone/packages-api";
import { IStoreState } from "../../../../reducers/types";
import { PackagePollState } from "../../actions/actions";

export const getPackageSearchKey = (state: IStoreState): string | null =>
  state.packageIdentity.searchKey;

export const getPackageDisplayData = (
  state: IStoreState
): PackageDisplayData | null => state.packageIdentity.data;

export const getPackagePollState = (state: IStoreState): PackagePollState =>
  state.packageIdentity.pollState;

type PackagedComponentEntryOfType<T extends PackagedComponentV2Enum> =
  PackagedComponentEntryV2 & {
    component: Extract<PackagedComponentV2, { componentType: T }>;
  };

const isPackagedComponentEntryOfType = <T extends PackagedComponentV2Enum>(
  entry: PackagedComponentEntryV2,
  componentType: T
): entry is PackagedComponentEntryOfType<T> =>
  entry.component.componentType === componentType;

const findPackagedComponentOfType = <T extends PackagedComponentV2Enum>(
  packageDisplayData: PackageDisplayData | null,
  componentType: T
): Extract<PackagedComponentV2, { componentType: T }> | undefined =>
  packageDisplayData?.products.find(
    (entry): entry is PackagedComponentEntryOfType<T> =>
      isPackagedComponentEntryOfType(entry, componentType)
  )?.component;

export const getPackagedAirComponent = (
  state: IStoreState
): PackagedAirV2 | undefined =>
  findPackagedComponentOfType(
    getPackageDisplayData(state),
    PackagedComponentV2Enum.PackagedAir
  );

export const getPackagedRoomComponent = (
  state: IStoreState
): PackagedRoomComponentV2 | undefined =>
  findPackagedComponentOfType(
    getPackageDisplayData(state),
    PackagedComponentV2Enum.PackagedRoom
  );
